export default "__VITE_ASSET__CNeElnP1__"